//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  getIndustry,
  getServiceContent,
  getServiceContents,
  getJobTitle,
  getMajor,
} from '@/assets/js/dict';
import { options } from '@/assets/js/city'
export default {
  props:['currentJob'],
  created(){
    this.options= options
    getIndustry().then(res => {
      this.industrys = res;
    })
    getServiceContent().then(res => {
      this.serviceList = res;
    })
    getServiceContents().then(res => {
      this.serviceLists = res;
    })
    getJobTitle().then(res => {
      this.jobTitles = res;
    })
    getMajor().then(res => {
      this.majorArray = res;
    })
  },
  data() {
    return {
      zhanshi:0,
      activeNames: ['1'],
      form: {
        completeNum: '', //完成数
        conductProjectNum: '', //项目数
        consultingFee: '', //费用
        industry: '', //行业
        serviceContent: '', //服务内容
        workMajor: '',
        jobTitle: '',
        isExpert: 1, //是否专家
        total: 10,
        pageSize: 10,
        pageIndex: 1,
        title: '',
        contactAddressCode: '',
      },
      industrys:[],
      serviceList:[],
      serviceLists:[],
      jobTitles:[],
      majorArray:[],
      industry:0,
      major:0,
      service:0,
      services:0
    };
  },

  methods: {
    //切换折叠面板
    handleChange(val) {
      
    },
    showCon(){
      this.zhanshi=1
    },
    //切换行业
    chooseIndustry(index, dictCode){
      this.industry = index;
      this.form.industry = dictCode;
    },
     //切换技术职称
     chooseJob(index, dictCode) {
      this.currentJob = index;
      this.form.jobTitle = dictCode;
    },
    //切换从事专业
    chooseMajor(index, dictCode) {
      this.major = index;
      this.form.workMajor = dictCode;
    },
     // 修改服务
     chooseService(index, dictCode) {
      this.service = index;
      this.form.serviceContent = dictCode;
      this.services=0
    },
    // 修改服务二级选择
    changeService(index, dictCode) {
      this.services = index;
      this.form.serviceContent = dictCode;
    },
    changeAddress(val) {
      if (val.length) {
        this.form.contactAddressCode = val[val.length - 1];
      } else {
        this.form.contactAddressCode = '';
      }
    },
    //重置搜索条件
    resetCon(){
      this.form.industry= ''//行业
      this.form.serviceContent= ''//服务内容
      this.form.workMajor= ''
      this.form.jobTitle= ''
      this.industry=0,
      this.currentJob=0,
      this.major=0,
      this.service=0,
      this.services=0
    },
    //确定搜索条件
    ensureCon(){
      this.form.pageIndex=1
      this.zhanshi=0
      this.$parent.getList(this.form)
    }
  },
  mounted: function () {},
};
